import Login from "../pages/Login/Login";
import ForgotPassword from "../components/ForgotPassword/ForgotPassword";
import ResetPassword from "../components/ResetPassword/ResetPassword";

import Dashboard from "../pages/Dashboard/Dashboard";
import ChangePassword from "../components/ChangePassword/ChangePassword";
import Profile from "../components/Profile/Profile";

import AddLanguageSetting from "../components/LanguageSetting/Add";
import ViewAllLanguageSetting from "../components/LanguageSetting/ViewAll";

import ViewAllSettings from "../components/Settings/ViewAll";
import ViewPrefix from "../components/Settings/ViewPrefix";
import AddSetting from "../components/Settings/Add";
import EditSetting from "../components/Settings/Edit";

import ViewAllCms from "../components/Cms/ViewAll";
import ViewOneCms from "../components/Cms/NewViewOne";
import AddCms from "../components/Cms/NewAdd";
import EditCms from "../components/Cms/NewEdit";

import ViewAllEmailTemplate from "../components/EmailTemplate/ViewAll";
import AddEmailTemplate from "../components/EmailTemplate/Add";
import EditEmailTemplate from "../components/EmailTemplate/Edit";
import ViewAllEmailLogs from "../components/EmailLog/ViewAll";

import CustomNotification from "../components/CustomNotification";
import CustomNotificationList from "../components/CustomNotification/List";
import CustomNotificationListAll from "../components/CustomNotification/ListAll";

import ViewAllNotificationTemplate from "../components/NotificationTemplate/ViewAll";
import AddNotificationTemplate from "../components/NotificationTemplate/Add";
import EditNotificationTemplate from "../components/NotificationTemplate/Edit";
import ViewOneNotificationTemplate from "../components/NotificationTemplate/ViewOne";

import ViewAllFaqs from "../components/Faq/ViewAll";
import AddFaq from "../components/Faq/Add";
import EditFaq from "../components/Faq/Edit";

import ViewAllAdminRole from "../components/SubAdminRoles/ViewAll";
import AddAdminRole from "../components/SubAdminRoles/Add";
import EditAdminRole from "../components/SubAdminRoles/Edit";

import SeoPageAdd from "../components/SeoPage/Add";
import SeoPageViewAll from "../components/SeoPage/ViewAll";
import SeoPageEdit from "../components/SeoPage/Edit";

import ViewAllCustomer from "../components/Customers/ViewAll";
import AddCustomer from "../components/Customers/Add";
import EditCustomer from "../components/Customers/Edit";
import ViewCustomer from "../components/Customers/ViewOne";
import ChangePasswordCustomer from "../components/Customers/ChangePassword";

import ViewAllStore from "../components/Store/ViewAll";
import AddStore from "../components/Store/Add";
import EditStore from "../components/Store/Edit";
import ViewStore from "../components/Store/ViewOne";
import ChangePasswordVendor from "../components/Store/ChangePassword";

import ViewAllOrder from "../components/Orders/ViewAll";
import ViewOrder from "../components/Orders/ViewOne";
import SendOffer from "../components/Orders/SendOffer";

import ViewOrderOffer from "../components/OrderOffer/ViewAll";
import ViewOffer from "../components/OrderOffer/ViewOne";

import ViewAllPosition from "../components/Position/ViewAll";
import AddPosition from "../components/Position/Add";
import EditPosition from "../components/Position/Edit";

import ViewAllBrand from "../components/CarBrand/ViewAll";
import AddBrand from "../components/CarBrand/Add";
import EditBrand from "../components/CarBrand/Edit";

import ViewAllModels from "../components/Models/ViewAll";
import AddModels from "../components/Models/Add";
import AddYear from "../components/ManufacturingYear/Add";
import EditYear from "../components/ManufacturingYear/Edit";

import AddVersion from "../components/CarVersion/Add";
import EditVersion from "../components/CarVersion/Edit";

import ViewAllModelsVersion from "../components/CarVersion/ViewAll";

import ViewAllModelsYear from "../components/ManufacturingYear/ViewAll";

import EditModels from "../components/Models/Edit";

import ViewAllSubAdmin from "../components/SubAdmin/ViewAll";
import AddSubAdmin from "../components/SubAdmin/Add";
import EditSubAdmin from "../components/SubAdmin/Edit";
import ChangePasswordSubAdmin from "../components/SubAdmin/ChangePassword";

import ViewAllCountry from "../components/Countries/ViewAll";
import AddCountry from "../components/Countries/Add";
import EditCountry from "../components/Countries/Edit";

import ViewAllCity from "../components/City/ViewAll";
import AddCity from "../components/City/Add";
import EditCity from "../components/City/Edit";

import ViewAllSpareSide from "../components/SpareSide/ViewAll";
import AddSpareSide from "../components/SpareSide/Add";

import EditSpareSide from "../components/SpareSide/Edit";

import AddOffer from "../components/Offers/Add";

import ViewAllOffers from "../components/Offers/ViewAll";
import EditOffers from "../components/Offers/Edit";

import ViewAllContactUs from "../components/ContactUs/ViewAll";
import ViewAllNewsletterSubscriptions from "../components/NewsletterSubscriptions/ViewAll";

import ViewAllHomePage from "../components/HomePage/ViewAll";
import ViewOneHomePage from "../components/HomePage/NewViewOne";
import AddHomePage from "../components/HomePage/NewAdd";
import EditHomePage from "../components/HomePage/NewEdit";
import Earnings from "../components/Earnings/ViewAll";
import PaymentHistory from "../components/paymentHistory/ViewAll";
import VendorPayout from "../components/vendorPayout/ViewAll";


import OrderReturn from "../components/OrderReturn/ViewAll"
import Brandrequest from "../components/Brandrequest/ViewAll"



// Checkout
import Checkout from "../pages/payment/checkout";
import Callback from "../pages/payment/callback";
import PaymentResponse from "../pages/payment/response";


export const privateRoutes = [
  { path: "/", component: Dashboard, key: "1" },
  { path: "/change-password", component: ChangePassword, key: "1_2" },
  { path: "/my-profile", component: Profile, key: "1_3" },

  { path: "/cms", component: ViewAllCms, key: "12_1" },
  { path: "/cms/view/:id", component: ViewOneCms, key: "12_2" },
  { path: "/cms/add", component: AddCms, key: "12_1" },
  { path: "/cms/edit/:id", component: EditCms, key: "12_3" },

  { path: "/email-template", component: ViewAllEmailTemplate, key: "12_20" },
  { path: "/email-template/add", component: AddEmailTemplate, key: "12_20" },
  {
    path: "/email-template/edit/:id",
    component: EditEmailTemplate,
    key: "12_21",
  },

  {
    path: "/notification-template",
    component: ViewAllNotificationTemplate,
    key: "12_60",
  },
  {
    path: "/notification-template/add",
    component: AddNotificationTemplate,
    key: "12_61",
  },
  {
    path: "/notification-template/edit/:id",
    component: EditNotificationTemplate,
    key: "12_62",
  },
  {
    path: "/notification-template/view/:id",
    component: ViewOneNotificationTemplate,
    key: "12_63",
  },
  {
    path: "/custom-notification/send",
    component: CustomNotification,
    key: "12_64",
  },
  {
    path: "/custom-notification/log/:id",
    component: CustomNotificationListAll,
    key: "12_67",
  },
  {
    path: "/custom-notification",
    component: CustomNotificationList,
    key: "12_66",
  },
  { path: "/email-logs", component: ViewAllEmailLogs, key: "12_30" },

  { path: "/faq", component: ViewAllFaqs, key: "12_40" },
  { path: "/faq/add", component: AddFaq, key: "12_41" },
  { path: "/faq/edit/:id", component: EditFaq, key: "12_43" },

  { path: "/seo-pages", component: SeoPageViewAll, key: "12_10" },
  { path: "/seo-page/add", component: SeoPageAdd, key: "12_10" },
  { path: "/seo-page/edit/:id", component: SeoPageEdit, key: "12_11" },

  { path: "/setting", component: ViewAllSettings, key: "13" },
  { path: "/setting/prefix/:prefix", component: ViewPrefix, key: "13_1" },
  { path: "/setting/add", component: AddSetting, key: "13_1" },
  { path: "/setting/edit/:id", component: EditSetting, key: "13_1" },

  { path: "/admin-roles", component: ViewAllAdminRole, key: "4_20" },
  { path: "/admin-role/add", component: AddAdminRole, key: "4_21" },
  { path: "/admin-role/edit/:id", component: EditAdminRole, key: "4_22" },

  { path: "/sub-admins", component: ViewAllSubAdmin, key: "4_1" },
  { path: "/sub-admin/add", component: AddSubAdmin, key: "4_2" },
  { path: "/sub-admin/edit/:id", component: EditSubAdmin, key: "4_3" },
  {
    path: "/sub-admin/change-password/:id",
    component: ChangePasswordSubAdmin,
    key: "4_25",
  },
  // customer management
  { path: "/customers", component: ViewAllCustomer, key: "2" },
  { path: "/customer/add", component: AddCustomer, key: "2_2" },
  { path: "/customer/edit/:id", component: EditCustomer, key: "2_5" },
  { path: "/customer/view/:id", component: ViewCustomer, key: "2_4" },


  {
    path: "/customer/change-password/:id",
    component: ChangePasswordCustomer,
    key: "2_8",
  },

  // brand request 

  { path: "/brand-request", component: Brandrequest, key: "12" },

  // store management
  { path: "/stores", component: ViewAllStore, key: "3" },
  { path: "/stores/add", component: AddStore, key: "3_2" },
  { path: "/stores/edit/:id", component: EditStore, key: "3_5" },
  { path: "/stores/view/:id", component: ViewStore, key: "3_4" },
  {
    path: "/stores/change-password/:id",
    component: ChangePasswordVendor,
    key: "3_7",
  },

  //order management
  { path: "/orders", component: ViewAllOrder, key: "3" },
  { path: "/orders/view/:id", component: ViewOrder, key: "3_4" },
  { path: "/orders/:id", component: ViewOrderOffer, key: "3_5" },
  { path: "/orders/offer/:id", component: ViewOffer, key: "3_5" },
  { path: "/orders/send-offer/:id", component: SendOffer },

  // offfer mange
  { path: "/offers/add", component: AddOffer, key: "3_2" },
  { path: "/offers", component: ViewAllOffers, key: "3_2" },
  { path: "/offers/edit/:id", component: EditOffers, key: "3_2" },

  // positions

  { path: "/positions", component: ViewAllPosition, key: "5" },
  { path: "/position/add", component: AddPosition, key: "5_2" },
  { path: "/position/edit/:id", component: EditPosition, key: "5_4" },

  // brands
  { path: "/brands", component: ViewAllBrand, key: "5_11" },
  { path: "/brands/add", component: AddBrand, key: "5_12" },
  { path: "/brands/edit/:id", component: EditBrand, key: "5_14" },

  { path: "/brands/:id", component: ViewAllModels, key: "5_21" },
  { path: "/brands/:id/models/add", component: AddModels, key: "5_22" },
  { path: "/brands/:id/models/edit/:id", component: EditModels, key: "5_24" },

  {
    path: "/brands/:id/models/year/:id",
    component: ViewAllModelsYear,
    key: "5_21",
  },

  { path: "/brands/:id/models/year/:id/add", component: AddYear, key: "6_25" },
  {
    path: "/brands/:id/models/year/:id/edit/:id",
    component: EditYear,
    key: "6_25",
  },

  {
    path: "/brands/:id/models/car-version/:id",
    component: ViewAllModelsVersion,
    key: "5_21",
  },
  {
    path: "/brands/:id/models/car-version/:id/edit/:id",
    component: EditVersion,
    key: "6_26",
  },

  {
    path: "/brands/:id/models/car-version/:id/add",
    component: AddVersion,
    key: "6_26",
  },

  // spare side
  { path: "/spare-side", component: ViewAllSpareSide, key: "14" },
  { path: "/spare-side/add", component: AddSpareSide, key: "14_1" },
  { path: "/spare-side/edit/:id", component: EditSpareSide, key: "14_2" },

  // countries
  { path: "/countries", component: ViewAllCountry, key: "15" },
  { path: "/countries/add", component: AddCountry, key: "15_1" },
  { path: "/countries/edit/:id", component: EditCountry, key: "15_2" },
  // cities
  { path: "/cities", component: ViewAllCity, key: "15" },
  { path: "/cities/add", component: AddCity, key: "15_1" },
  { path: "/cities/edit/:id", component: EditCity, key: "15_2" },



  { path: "/contact-us", component: ViewAllContactUs, key: "12_200" },
  { path: "/languages", component: ViewAllLanguageSetting, key: "12_140" },
  { path: "/language/add", component: AddLanguageSetting, key: "12_140" },
  {
    path: "/newsletter-subscriptions",
    component: ViewAllNewsletterSubscriptions,
    key: "12_201",
  },

  { path: "/home-page", component: ViewAllHomePage, key: "12_1" },
  { path: "/home-page/view/:id", component: ViewOneHomePage, key: "12_2" },
  { path: "/home-page/add", component: AddHomePage, key: "12_1" },
  { path: "/home-page/edit/:id", component: EditHomePage, key: "12_3" },
  { path: "/earnings", component: Earnings, key: "12_5" },
  { path: "/payment-history", component: PaymentHistory, key: "12_6" },
  { path: "/vendor-earning", component: VendorPayout, key: "12_07" },

  { path: "/return-orders", component: OrderReturn, key: "3_2" },
  
];

export const notPrivateRoutes = [
  { path: "/login", component: Login },
  { path: "/forgot-password", component: ForgotPassword },
  { path: "/reset-password/:token", component: ResetPassword },
  { path: "/checkout", component: Checkout },
  { path: "/payment/callback", component: Callback },
  { path: "/payment/response", component: PaymentResponse },
];
